/**
 * Do not edit directly
 * Generated on Thu, 05 Jan 2023 16:02:21 GMT
 */

export const LightMode = {
  system: {
    strong: {
      neutral: "rgba(117, 117, 117, 1)",
      positive: "rgba(28, 132, 80, 1)",
      negative: "rgba(217, 54, 56, 1)",
      warning: "rgba(253, 184, 64, 1)",
      information: "rgba(49, 115, 201, 1)",
    },
    subtle: {
      neutral: "rgba(240, 240, 240, 1)",
      positive: "rgba(228, 240, 234, 1)",
      negative: "rgba(250, 231, 231, 1)",
      warning: "rgba(255, 238, 209, 1)",
      information: "rgba(230, 238, 249, 1)",
    },
  },
  accent: {
    primary: {
      strong: "rgba(251, 207, 9, 1)",
      medium: "rgba(251, 207, 9, 0.6)",
      subtle: "rgba(251, 207, 9, 0.2)",
    },
    secondary: {
      strong: "rgba(221, 29, 33, 1)",
      medium: "rgba(221, 29, 32, 0.6)",
      subtle: "rgba(221, 29, 32, 0.1)",
    },
    tertiary: {
      strong: "rgba(0, 60, 138, 1)",
      medium: "rgba(0, 60, 138, 0.6)",
      subtle: "rgba(0, 60, 138, 0.1)",
    },
  },
  background: {
    surface: "rgba(255, 255, 255, 1)",
    raised: "rgba(255, 255, 255, 1)",
    base: "rgba(245, 245, 245, 1)",
    section: "rgba(0, 0, 0, 0.04)",
    inactive: "rgba(245, 245, 245, 1)",
    inverted: "rgba(64, 64, 64, 1)",
    mask: "rgba(0, 0, 0, 0.11)",
  },
  border: {
    medium: "rgba(0, 0, 0, 0.15)",
    subtle: "rgba(0, 0, 0, 0.06)",
    strong: "rgba(0, 0, 0, 0.35)",
  },
  text: {
    onSurface: {
      strong: "rgba(64, 64, 64, 1)",
      subtle: "rgba(117, 117, 117, 1)",
      inactive: "rgba(217, 217, 217, 1)",
      link: "rgba(50, 97, 159, 1)",
      hover: "rgba(101, 137, 184, 1)",
      visited: "rgba(133, 71, 133, 1)",
      positive: "rgba(25, 118, 71, 1)",
      negative: "rgba(204, 41, 44, 1)",
      warning: "rgba(146, 94, 4, 1)",
      information: "rgba(49, 106, 180, 1)",
    },
    onInverted: {
      strong: "rgba(255, 255, 255, 0.97)",
      subtle: "rgba(255, 255, 255, 0.57)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(154, 178, 208, 1)",
      hover: "rgba(101, 137, 184, 1)",
      visited: "rgba(193, 164, 193, 1)",
    },
    onPrimary: {
      strong: "rgba(64, 64, 64, 1)",
      subtle: "rgba(89, 89, 89, 1)",
      inactive: "rgba(0, 0, 0, 0.25)",
      link: "rgba(64, 64, 64, 1)",
    },
    onSecondary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 1)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(255, 255, 255, 1)",
    },
    onTertiary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 1)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(255, 255, 255, 1)",
    },
    onFocus: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(0, 0, 0, 0.75)",
      inactive: "rgba(0, 0, 0, 0.25)",
      link: "rgba(0, 0, 0, 0.75)",
    },
    onBase: {
      strong: "rgba(38, 38, 38, 1)",
      subtle: "rgba(89, 89, 89, 1)",
      inactive: "rgba(191, 191, 191, 1)",
      link: "rgba(50, 97, 159, 1)",
      hover: "rgba(101, 137, 184, 1)",
      visited: "rgba(133, 71, 133, 1)",
    },
    onSystem: {
      strong: {
        neutral: "rgba(255, 255, 255, 1)",
        positive: "rgba(255, 255, 255, 1)",
        negative: "rgba(255, 255, 255, 1)",
        warning: "rgba(64, 64, 64, 1)",
        information: "rgba(255, 255, 255, 1)",
      },
      subtle: {
        neutral: "rgba(89, 89, 89, 1)",
        positive: "rgba(25, 118, 71, 1)",
        negative: "rgba(204, 41, 44, 1)",
        warning: "rgba(146, 94, 4, 1)",
        information: "rgba(49, 106, 180, 1)",
      },
    },
  },
  focus: {
    medium: "rgba(0, 151, 187, 0.4)",
    subtle: "rgba(0, 151, 187, 0.1)",
    strong: "rgba(0, 151, 187, 1)",
  },
  series: {
    1: "rgba(0, 151, 187, 1)",
    2: "rgba(50, 97, 159, 1)",
    3: "rgba(133, 71, 133, 1)",
    4: "rgba(241, 167, 168, 1)",
    5: "rgba(239, 160, 57, 1)",
    6: "rgba(253, 225, 104, 1)",
    7: "rgba(191, 215, 15, 1)",
    8: "rgba(51, 158, 106, 1)",
    9: "rgba(137, 207, 220, 1)",
    10: "rgba(101, 137, 184, 1)",
    11: "rgba(185, 147, 189, 1)",
    12: "rgba(228, 73, 76, 1)",
    13: "rgba(247, 208, 156, 1)",
    14: "rgba(251, 207, 9, 1)",
    15: "rgba(216, 230, 112, 1)",
    16: "rgba(152, 205, 179, 1)",
  },
  elevation: {
    level0: "0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.1)",
    level1: "0px 2px 5px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1)",
    level2: "0px 6px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.1)",
    level3:
      "0px 10px 40px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.1)",
    level4:
      "0px 20px 64px rgba(0, 0, 0, 0.12), 0px 16px 24px rgba(0, 0, 0, 0.08)",
    level5:
      "0px 24px 80px rgba(0, 0, 0, 0.16), 0px 16px 32px rgba(0, 0, 0, 0.06)",
  },
};
